import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Spin } from 'antd';

import { ticketsStatsTags } from 'constants/business-details';

import BRTag from 'components/BRTag/BRTag';

import './StatsTags.less';

const StatsTags = ({ ticketsData = [], loading }) => {
  const { formatMessage } = useIntl();

  const ticketsDataFormatter = useMemo(
    () =>
      Object.fromEntries(
        ticketsData?.map(({ _id, count }) => [
          _id?.toLowerCase().replaceAll(' ', '_'),
          count
        ])
      ),
    [ticketsData]
  );

  const orderedTags = useMemo(() => {
    return ticketsStatsTags
      ?.map(({ label, color }, index) => {
        const key = label.toLowerCase().replaceAll(' ', '_');
        const count = ticketsDataFormatter[key];

        if (count === null || count === undefined) return null;

        return {
          label,
          color: color || 'gray',
          count
        };
      })
      .filter(Boolean);
  }, [ticketsDataFormatter]);

  return (
    <div className="br-budget__departments-status">
      {loading ? (
        <Spin />
      ) : (
        <>
          <span className="caption-medium">
            {formatMessage({
              id: 'merchant_analysis.freshdesk_table.tickets_status'
            })}
          </span>
          {orderedTags?.map(({ label, color, count }) => (
            <BRTag
              key={label}
              showDot
              color={color}
              children={`${count} ${label}`}
              bgGrayColor={true}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default StatsTags;
